import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../shared/Card';
import { ProgressBar } from '../shared/ProgressBar';

interface ProgressItem {
  label: string;
  progress: number;
  color: 'primary' | 'secondary' | 'accent';
}

const progressData: ProgressItem[] = [
  { label: 'Academic Goals', progress: 75, color: 'primary' },
  { label: 'Extracurricular Hours', progress: 60, color: 'secondary' },
  { label: 'College Research', progress: 40, color: 'accent' },
  { label: 'Portfolio Completion', progress: 85, color: 'primary' },
];

export const ProgressOverview: React.FC = () => {
  return (
    <Card>
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Progress Overview</h3>
      <div className="space-y-6">
        {progressData.map((item, index) => (
          <motion.div
            key={item.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.15 }}
          >
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium text-gray-700">{item.label}</span>
              <span className="text-sm text-gray-500">{item.progress}%</span>
            </div>
            <ProgressBar
              progress={item.progress}
              color={item.color}
              size="md"
            />
          </motion.div>
        ))}
      </div>
    </Card>
  );
};